import i18n from "../../../i18n";

const AnalysisMandatoryAssortmentLotGridPluginSettings = (): IPluginSettings => {
    const t = (value: string) => i18n.t("sidePanel." + value);
    let index = 0
    return {
        name: t("accounting.submenu.analysisMandatoryAssortmentLot"),
        mnemocode: 'analysis_mandatory_assortment_report_lot_plugin',
        permission: 'Lot',
        columns: [{
            order: index++,
            propertyName: 'idGoodsGlobal',
            propertyType: 'string',
            displayName: 'idGoodsGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'goodsCode',
            propertyType: 'string',
            displayName: 'Код товара',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'goodsName',
            propertyType: 'string',
            displayName: 'Товар',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'producerName',
            propertyType: 'string',
            displayName: 'Производитель',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'countryName',
            propertyType: 'string',
            displayName: 'Страна',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'isGnvls',
            propertyType: 'boolean',
            displayName: 'ЖНВЛП',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'IdGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idContractorGlobal',
            propertyType: 'string',
            displayName: 'idContractorGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'contractorName',
            propertyType: 'string',
            displayName: 'Аптека',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'quantityTotal',
            propertyType: 'number',
            displayName: 'Общее количество',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'retailPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена розн. c НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'supplierPriceIncVat',
            propertyType: 'number',
            displayName: 'Цена поставщика с НДС',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'idStoreGlobal',
            propertyType: 'string',
            displayName: 'idStoreGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'idProducerGlobal',
            propertyType: 'string',
            displayName: 'idProducerGlobal',
            visibility: false,
            width: 150
        }, {
            order: index++,
            propertyName: 'cureFormName',
            propertyType: 'string',
            displayName: 'Лекарственная форма',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'mnn',
            propertyType: 'string',
            displayName: 'МНН',
            visibility: true,
            width: 150
        }, {
            order: index++,
            propertyName: 'quantityRem',
            propertyType: 'number',
            displayName: 'Доступный остаток',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: 'quantityRes',
            propertyType: 'number',
            displayName: 'Резерв',
            visibility: true,
            width: 150
        }
    ]
    }
}
export default AnalysisMandatoryAssortmentLotGridPluginSettings